import { FC } from 'react'

import { Text, View } from '@react-pdf/renderer'

import i18n from 'modules/core/lib/i18n'

const Footer: FC = () => (
  <View
    style={{
      flex: 1,
      alignItems: 'center',
      position: 'absolute',
      bottom: 24,
      left: 0,
      right: 0,
    }}
    fixed
  >
    <Text style={{ fontSize: 9, color: '#515164' }}>
      {i18n.t('procurement.purchase_orders.pdf.powered_by')}
      <Text style={{ color: '#FF355E' }}> Factorial</Text>
    </Text>
  </View>
)

export default Footer
